import { makeStyles } from "@material-ui/core/styles";
import DoneIcon from "@material-ui/icons/Done";
import EditIcon from "@material-ui/icons/Edit";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch } from "react-router-dom";

import { useStateValue } from "../../config/AppContext";
import Carousel from "../Utilities/Carousel";

const useStyles = makeStyles((theme) => ({
  section: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    textTransform: "capitalize",
    marginTop: "-10px",
  },
  label: {
    display: "block",
    color: "var(--heading)",
    marginBottom: 2,
  },
  textAreaHover: {
    "&:focus": {
      boxShadow: "none",
    },
  },
  editText: {
    color: "var(--text-primary)",
    cursor: "pointer",
    marginBottom: 5,
    float: "right",
  },
}));

const ExerciseDetailsComponent = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { catalog } = useStateValue();
  let { id, exercise_id, exercise_notes } = props.drawerId || props.match.params;

  const exercise = catalog?.findExercise(exercise_id ? exercise_id : id);

  exercise_notes = exercise_notes || exercise.notes;

  const [edit, setEdit] = React.useState(false);
  const [exerciseNote, setExerciseNote] = React.useState(exercise_notes);
  if (!exercise || !catalog) return <></>;
  return (
    <div id="exercise-detail">
      <section style={{ margin: "-10px 0% 0 0%" }}>
        <Carousel exercise-item={exercise} />
      </section>
      <section
        style={
          props.mystyle
            ? window.innerWidth > 700
              ? { position: "absolute", top: 65, right: 90, width: "52vw" }
              : {}
            : {}
        }
      >
        {props.children}
      </section>
      <section className={classes.section}>
        <div
          className="meraNewCard"
          // style={{
          //   gridColumn:
          //     exercise.type.toString() === ExerciseTypes[4] ? 'auto' : 'span 2',
          // }}
        >
          <label className={classes.label}>{t("Name")}</label>
          {catalog.typesDisplay(exercise.name.toString()).toLowerCase()}
        </div>
        <div
          className="meraNewCard"
          // style={{
          //   gridColumn:
          //     exercise.type.toString() === ExerciseTypes[4] ? 'auto' : 'span 2',
          // }}
        >
          <label className={classes.label}>{t("Type")}</label>
          {catalog.typesDisplay(exercise.type.toString()).toLowerCase()}
        </div>
        {/* {exercise.type.toString() === ExerciseTypes[4] && (
          <div className='meraNewCard'>
            <label style={{ display: 'block', color: 'var(--heading)' }}>
              {t('Subtype')}
            </label>
            {exercise.subtype
              ? catalog.typesDisplay(exercise.subtype.toString()).toLowerCase()
              : ''}
          </div>
        )} */}
        {exercise.equipment && (
          <div className="meraNewCard">
            <label className={classes.label}>{t("Equipment")}</label>
            {catalog.equipmentsDisplay(exercise.equipment?.toString())?.toLowerCase()}
          </div>
        )}
      </section>
      <section
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
        }}
      >
        <div className="meraNewCard" style={{ textTransform: "none" }}>
          <label style={{ display: "block", color: "var(--heading)" }}>{t("Primary focus")}</label>
          {exercise.focus_prim ? exercise.focus_prim.toString().toLowerCase() : "none"}
        </div>
        <div className="meraNewCard" style={{ textTransform: "none" }}>
          <label style={{ display: "block", color: "var(--heading)" }}>
            {t("Secondary focus")}
          </label>
          {exercise.focus_sec ? exercise.focus_sec.toString().toLowerCase() : "none"}
        </div>
      </section>
      <section>
        <Switch>
          <Route exact path={["/exercises", "/exercises/:id"]}>
            {exercise.is_user_exercise && (
              <div className="meraNewCard">
                <label style={{ display: "block", color: "var(--heading)" }}>
                  {t("Exercise notes")}
                </label>
                <p>{exercise.notes ? exercise.notes : "-"}</p>
              </div>
            )}
          </Route>
          <Route
            exact
            path={["/", "/clients/sessions/:id", "/workouts/:id", "/schedules", "/workouts/"]}
          >
            <div className="meraNewCard" style={{ width: "58%" }}>
              <label
                style={{
                  color: "var(--heading)",
                  cursor: "pointer",
                  marginBottom: 2,
                }}
                onClick={() => {
                  if (edit) {
                    // const exerciseNotes = document.getElementById(
                    //   'exercise_notes'
                    // ) as HTMLInputElement | null;
                    // if (!exerciseNotes) return;
                    // exerciseNotes.setAttribute('value', exercise_notes);
                  }
                  return setEdit(!edit);
                }}
              >
                {t("Exercise notes")}{" "}
                <span
                  className={classes.editText}
                  // className={`btn btn-outline-${edit ? 'danger' : 'primary'}`}
                >
                  {edit ? (
                    <>
                      {/* <CloseIcon fontSize="small"/> {t("Cancel")} */}
                      <DoneIcon fontSize="small" /> {t("Done")}
                    </>
                  ) : (
                    <>
                      <EditIcon fontSize="small" /> {t("Edit")}
                    </>
                  )}
                </span>
              </label>
              <input
                type="text"
                id="exercise_notes"
                name="exercise_notes"
                className="form-control"
                value={exerciseNote}
                style={{ display: "none" }}
              />
              {edit ? (
                <textarea
                  rows={3}
                  className={`form-control ${classes.textAreaHover}`}
                  defaultValue={exerciseNote}
                  onChange={(e) => {
                    // const exerciseNotes = document.getElementById(
                    //   'exercise_notes'
                    // ) as HTMLInputElement | null;
                    // if (!exerciseNotes) return;
                    // return exerciseNotes.setAttribute(
                    //   'value',
                    //   e.currentTarget.value
                    // );
                    setExerciseNote(e.currentTarget.value);
                  }}
                />
              ) : (
                <p>{exerciseNote || "-"}</p>
              )}
            </div>
          </Route>
        </Switch>
      </section>

      <section style={{ paddingBottom: "20px" }}>
        <div className="meraNewCard">
          <label
            style={{
              display: "block",
              color: "var(--heading)",
              marginBottom: 2,
            }}
          >
            {t("Description")}
          </label>
          {exercise.description}
        </div>
      </section>
    </div>
  );
};

export default ExerciseDetailsComponent;
